import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { AddVideoArea, All, LoadVideoAreas, RemoveVideoArea } from '../../actions/area'
import { VideoAreaApi } from '../../apis'
import { Area } from '../../models'
import { AppState } from '../../reducers'
import { AreaService } from './base'

@Injectable()
export class VideoAreaService extends AreaService{
  protected LoadAreas(resourceId: number, areas: Area[]): All {
    return new LoadVideoAreas(resourceId, areas)
  }
  protected AddArea(area: Area): All {
    return new AddVideoArea(area)
  }
  protected RemoveArea(areaId: number): All {
    return new RemoveVideoArea(areaId)
  }
  constructor(protected api: VideoAreaApi, protected store: Store<AppState>) {
    super(api, store)
  }
}



// WEBPACK FOOTER //
// ./src/services/area/video.ts